import { Component, HostListener, OnInit} from '@angular/core';
import _moment from 'moment';
import { AuthService } from './modules/core/services/auth/auth.service';
import { distinctUntilChanged, fromEvent, map, merge, take } from 'rxjs';
import { StatusService } from './modules/core/services/user/status.service';
import { SharedService } from './modules/shared/services';
declare var Idle: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  logoutAlreadyCalled: boolean = false;
  inActivityTime: number = (100 * 60 * 1000) - 5;
  lastActivityTime: any;
  activeTimer = undefined;
  tokenTimer = undefined;

  constructor(private _authService: AuthService,
    public _statusService: StatusService,
    public _sharedService: SharedService  
  ) {}
  ngOnInit(): void {
    this._authService.loginStatusChanged.next(this._authService.checkToken());

    this._authService.loginStatusChanged.pipe(
      distinctUntilChanged()
    ).subscribe((state) => {
      if (state) {
        this.idleInit();
        this.refresTokenWithExpire();
      } else {
        clearTimeout(this.tokenTimer);
        this._statusService.setPermissionCodesChild(null);
        this._statusService.setPermissionCodesParent(null);
      }
    });

    this.isLoginPage();

    merge(
          fromEvent(window, 'online').pipe(map(() => true)),
          fromEvent(window, 'offline').pipe(map(() => false)),
        ).subscribe(isOnline => {
          this._sharedService.isOnline$.next(isOnline);
        });
  }

  private idleInit() {
    let customIdleCounter = new Idle({
      onVisible: this.onVisibleCallback,
      onAway: this.awayCallback,
      onAwayBack: this.awayBackCallback,
      parentKaThis: this,
      awayTimeout: this.inActivityTime,
    }).start();

    this.logoutAlreadyCalled = false;
  }

  refresTokenWithExpire() {
    const RETRY_DELAY_MS = 30000; // retry after 30s on failure

    // clear any existing timer to avoid duplicates
    if (this.tokenTimer) {
      clearTimeout(this.tokenTimer);
      this.tokenTimer = undefined;
    }

    if (sessionStorage.getItem('token_expiry_web')) {
      const dateExpire = parseInt(sessionStorage.getItem('token_expiry_web'));
      const msUntilRefresh = dateExpire - Date.now() - 60000; // refresh 1 minute before expiry

      const scheduleRefresh = (delayMs: number) => {
        // protect against very large timeouts (setTimeout uses 32-bit signed int internally)
        const MAX_TIMEOUT = 2147483647;
        const delay = Math.min(Math.max(0, Math.round(delayMs)), MAX_TIMEOUT);
        this.tokenTimer = setTimeout(() => {
          this._authService.refreshToken().subscribe(
            (res) => {
              try {
                this._authService.saveToken(res);
              } catch (e) {
                // swallow save errors but continue scheduling
              }
              // schedule next refresh based on new expiry
              this.refresTokenWithExpire();
            },
            (err) => {
              // on error, wait a bit before trying again to avoid fast retry loops
              this.tokenTimer = setTimeout(() => {
                this.refresTokenWithExpire();
              }, RETRY_DELAY_MS);
            }
          );
        }, delay);
      };

      if (msUntilRefresh <= 0) {
        // token is already near or past expiry - try refresh soon but not immediately in a tight loop
        scheduleRefresh(1000);
      } else {
        scheduleRefresh(msUntilRefresh);
      }
    }
  }

  logoutInactiveUser() {
    this._authService.loginStatusChanged
      .pipe(take(1))
      .subscribe((IsLoggedIn) => {
        console.debug('IsLoggedIn', IsLoggedIn)
        console.debug('logoutAlreadyCalled', this.logoutAlreadyCalled)
        if (IsLoggedIn && !this.logoutAlreadyCalled) {
          this.logoutAlreadyCalled = true;
          this._authService.logoutUser(true);
        }
      })
  }

  private awayCallback(active) {
    active.logoutInactiveUser();
  }
  private awayBackCallback(active) {
    if (active.compareTime() >= active.inActivityTime) {
      active.logoutInactiveUser();
    }
  }
  private onVisibleCallback(active) {
    if (active.compareTime() >= active.inActivityTime) {
      active.logoutInactiveUser();
    }
  }

  compareTime(): number {
    let diffMinutes = _moment().diff(this.lastActivityTime, 'minutes');
    let diffMilliSecs = diffMinutes * 60 * 1000;
    return diffMilliSecs;
  }

  setCurrentTime() {
    this.lastActivityTime = _moment();
  }

  @HostListener('window:mousemove')
  @HostListener('window:click')
  @HostListener('window:keydown')
  refreshUserStateKeyboard() {
    if (this.activeTimer) {
      clearTimeout(this.activeTimer);
    }
    this.activeTimer = setTimeout(() => {
      this.setCurrentTime();
    }, 1500);
  }

  isLoginPage(): boolean {
    const urlPath = window.location.hash.split('/'); // Split the URL path after the hash by '/'
    return urlPath.includes('main') || urlPath.includes('login');
}
}
